import { CommonModule, DatePipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { Component, OnInit, ViewChild, AfterViewInit, ViewChildren, QueryList } from '@angular/core';
import { FormsModule, ReactiveFormsModule, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import {
  MatDialog, MatDialogRef,
  MatDialogActions,
  MatDialogClose,
  MatDialogTitle,
  MatDialogContent,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router, RouterModule } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { InputRestrictionDirective } from '../../../../Directives/input-restriction.directive';
import { MaterialModule } from '../../../../material.module';
import { LocalStorageService } from '../../../../Shared/common/local-storage.service';
import { CharitiesService } from '../../charities/services/charities.service';
import { TrailBalanceService } from '../trail-balance.service';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import * as XLSX from 'xlsx';
import { MessageServiceService } from '../../../../Shared/common/message-service.service';
import Swal from 'sweetalert2';
import { NonNegativeOnlyDirective } from '../../../../Directives/non-negative-only.directive';
import { Observable } from 'rxjs';
import { CharityDataShareServiceService } from '../../charities/services/charity-data-share-service.service';
import { TwoDigitDecimalNumberDirective } from '../../../../Directives/two-digit-decimal-number.directive';
import { BalanceSheetapiService } from '../../balancesheet/balance-sheetapi.service';
import { Editor, NgxEditorComponent, Toolbar, NgxEditorMenuComponent } from 'ngx-editor';
import { BaseEntityModel } from '../../../../Data/Models/Common/base-entity-model';
import { Email_Configuration_Model } from '../../../../Data/Models/Email_Configuration_Model/Email_Configuration_Model';
import { Email_Configuration_Service } from '../../../../services/Email_Configuration_Service/Email_Configuration_Service';
import { HttpErrorResponse } from '@angular/common/module.d-CnjH8Dlt';
import { ReportsService } from '../../reports/reports.service';

import { PdfJsViewerComponent, PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { UsermanagementService } from '../../../../services/apps/usermanagement/usermanagement.service';
import { RolesModel } from '../../../../Data/Models/Users/roles-model';
import { NotesDatashareService } from '../../notes/services/notes-datashare.service';
import { AccountDetails, TrailBalanceModal } from '../trailbalance-01/trailbalance-modal';

export interface TrialBalanceData {
  Category: any;
  accountCode: any;
  CategoryID: any;
  accountName: any;
  particulars: any;
  openingBalanceDebit: any;
  openingBalanceCredit: any;
  currentPeriodDebit: any;
  currentPeriodCredit: any;
  unrestrictedDebit: any;
  unrestrictedCredit: any;
  restrictedDebit: any;
  restrictedCredit: any;
  endowmentDebit: any;
  endowmentCredit: any;
  closingBalanceDebit: any;
  closingBalanceCredit: any;
  

}


@Component({
  selector: 'app-trial-balance-example',// selector: 'app-trial-balance-example',
  imports: [
    MaterialModule,
    TablerIconsModule,
    MatNativeDateModule, MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent, MatDialogModule, PdfJsViewerModule,
    NgScrollbarModule, RouterModule,
    CommonModule, FormsModule, ReactiveFormsModule, MatRadioModule, InputRestrictionDirective, NonNegativeOnlyDirective, TwoDigitDecimalNumberDirective, NgxEditorComponent, NgxEditorMenuComponent,
  ],
  providers: [DatePipe],
  //templateUrl: './trailbalance-01.component.html',
  //styleUrl: './trailbalance-01.component.scss'
  templateUrl: './trial-balance-example.component.html',
  styleUrl: './trial-balance-example.component.scss'
})
export class TrialBalanceExampleComponent implements OnInit, AfterViewInit {//TrialBalanceExampleComponent
  @ViewChild('dropdownRef', { static: false }) dropdownRef: MatSelect;
  @ViewChildren('selectRef') selectRefs: QueryList<MatSelect>;
  displayedColumns: string[] = [];
  displayedColumnsDiff1: string[] = [];
  displayedColumnsDiff2: string[] = [];
  displayedColumns2: string[] = [];
  subcolumns: string[] = [];
  isFundTracking: boolean = false;
  apFinalised: boolean = false
  ShowSpinner: any = false;
  dataSource: MatTableDataSource<TrialBalanceData>;
  dataSource2: MatTableDataSource<TrialBalanceData>;
  TotalDebits = 0;
  ExcellTotalDebits = 0;
  TotalCredits = 0;
  ExcellTotalCredits = 0;
  Difference = 0;
  ExcellDifference = 0;
  TotalUnrestrictedDebit = 0;
  TotalUnrestrictedCredit = 0;
  TotalRestrictedCredit = 0;
  TotalRestrictedDebit = 0;
  TotalEndowmentDebit = 0;
  TotalEndowmentCredit = 0;
  TotalcurrentPeriodDebit = 0
  TotalcurrentPeriodCredit = 0
  TotalPY_Debit = 0;
  TotalPY_Credit = 0;

  DBTotalUnrestrictedDebit = 0;
  DBTotalUnrestrictedCredit = 0;
  DBTotalRestrictedCredit = 0;
  DBTotalRestrictedDebit = 0;
  DBTotalEndowmentDebit = 0;
  DBTotalEndowmentCredit = 0;
  DBTotalcurrentPeriodDebit = 0
  DBTotalcurrentPeriodCredit = 0
  DBTotalclosingBalanceDebit = 0
  DBTotalclosingBalanceCredit = 0
  DBTotalPY_Debit = 0;
  DBTotalPY_Credit = 0;

  ExcelTotalUnrestrictedDebit = 0;
  ExcelTotalUnrestrictedCredit = 0;
  ExcelTotalRestrictedCredit = 0;
  ExcelTotalRestrictedDebit = 0;
  ExcelTotalEndowmentDebit = 0;
  ExcelTotalEndowmentCredit = 0;


  ExcelTotalcurrentPeriodDebit = 0
  ExcelTotalcurrentPeriodCredit = 0

  openImport: boolean = true;
  OpenErrors: boolean = false



  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  firstFormGroup = this._formBuilder.group({
    firstCtrl: ['', Validators.required],
  });
  secondFormGroup = this._formBuilder.group({
    secondCtrl: ['', Validators.required],
  });
  TrailBalanceTemplate: AccountDetails[] = [];
  Basicinfodata: any[] = []
  PreviousYear: boolean = false;
  ExcelTrailBalanceTemplate: AccountDetails[] = [];
  MainTrailBalanceTemplate: AccountDetails[] = [];
  Templateheder: AccountDetails[] = [];
  ExcellDropDownData: any[] = [];
  SeletedTeplateData: any[] = [];
  selectedFile: File | null = null;
  selectedFileName: any = 'No File Chosen';
  selectedFileValid: any = false;
  selectedFileSize: any = 0;
  DBTotalCredits: any = 0
  DBTotalDebits: any = 0;
  progressExcelLoad: number = 0;
  comapreSize: any = 0;
  maximumSizeExceeds: boolean = true;
  invalidFileFormat: boolean = true;
  exceldata: any;
  MainExcelTrailBalanceTemplate: AccountDetails[];
  saveType: any;
  RecandPay: any;
  DisableSavebtn: boolean = false;
  editor1: Editor;
  pdfFile: string;
  Downloadreportname: string;
  PeriodID: any;
  UserId: any;
  CentralUser: any;
  charityId: any;
  disablePreview: boolean = true;
  IsFirstAcctPeriod: any;
  @ViewChild('pdfViewerAutoLoad', { static: false }) pdfViewerAutoLoad: PdfJsViewerComponent
  UserRoleAccess: RolesModel;
    Showpreview: boolean=false;
  CurrentUserName: string;
  searchTerm: string = ''
  noRecordsfound: any = false
  SubmissionStatus: any;
  constructor(private reportservice: ReportsService, private datashare: NotesDatashareService, private emailConfigService: Email_Configuration_Service, public dialog: MatDialog, private _formBuilder: FormBuilder, private msgService: MessageServiceService, private lsService: LocalStorageService, private Charities_Service: CharitiesService, private fb: FormBuilder,
    private sharedService: CharityDataShareServiceService, private router: Router, private trailBalanceService: TrailBalanceService, private dataShareService: CharityDataShareServiceService, private apiservice: BalanceSheetapiService, private _UsermanagementService: UsermanagementService) {
    
    const dummyData: any[] = [

      { type: 'header', text: 'Income and endowments from' },
      {
        "accountCode": "S01",
        "accountName": "Donations and gifts",
        "particulars": "Donations and gifts",
        "openingBalanceDebit": null,
        "openingBalanceCredit": null,
        "currentPeriodDebit": null,
        "currentPeriodCredit": null,
        "unrestrictedDebit": null,
        "unrestrictedCredit": null,
        "restrictedDebit": null,
        "restrictedCredit": null,
        "endowmentDebit": null,
        "endowmentCredit": null,
      },
      {
        "accountCode": "S01",
        "accountName": "Donations and gifts",
        "particulars": "Donations and gifts",
        "openingBalanceDebit": null,
        "openingBalanceCredit": null,
        "currentPeriodDebit": null,
        "currentPeriodCredit": null,
        "unrestrictedDebit": null,
        "unrestrictedCredit": null,
        "restrictedDebit": null,
        "restrictedCredit": null,
        "endowmentDebit": null,
        "endowmentCredit": null,
      },
      {
        "accountCode": "S01",
        "accountName": "Donations and gifts",
        "particulars": "Donations and gifts",
        "openingBalanceDebit": null,
        "openingBalanceCredit": null,
        "currentPeriodDebit": null,
        "currentPeriodCredit": null,
        "unrestrictedDebit": null,
        "unrestrictedCredit": null,
        "restrictedDebit": null,
        "restrictedCredit": null,
        "endowmentDebit": null,
        "endowmentCredit": null,
      },
      {
        "accountCode": "S01",
        "accountName": "Donations and gifts",
        "particulars": "Donations and gifts",
        "openingBalanceDebit": null,
        "openingBalanceCredit": null,
        "currentPeriodDebit": null,
        "currentPeriodCredit": null,
        "unrestrictedDebit": null,
        "unrestrictedCredit": null,
        "restrictedDebit": null,
        "restrictedCredit": null,
        "endowmentDebit": null,
        "endowmentCredit": null,
      },
      {
        "accountCode": "S01",
        "accountName": "Donations and gifts",
        "particulars": "Donations and gifts",
        "openingBalanceDebit": null,
        "openingBalanceCredit": null,
        "currentPeriodDebit": null,
        "currentPeriodCredit": null,
        "unrestrictedDebit": null,
        "unrestrictedCredit": null,
        "restrictedDebit": null,
        "restrictedCredit": null,
        "endowmentDebit": null,
        "endowmentCredit": null,
      },
    ]
    debugger
    var  parsedUser1: any = localStorage.getItem('currentUser');
    const parsedUser = JSON.parse(parsedUser1);
    this.CurrentUserName = `${parsedUser.firstName} ${parsedUser.lastName}`;
    this.Getbasicinformation()
    this.dataSource = new MatTableDataSource<TrialBalanceData>(dummyData);
    this.dataSource2 = new MatTableDataSource<TrialBalanceData>(dummyData);
  }
  ngOnInit() {
    this.sharedService.finalStatus$.subscribe((value: any) => {
      this.apFinalised = value != '' && value == 'Completed'
    })
    this.SubmissionStatus = localStorage.getItem('SubmissionStatus');
    this.sharedService.AccountMethodType$.subscribe((value: any) => {
      this.RecandPay = value
    })
    this.datashare.isdirty$.subscribe(value => {
      this.isdirty = value
    })
    this.editor1 = new Editor();
    this.GetUserAccess()
    this.GetTrailbalancetemplate()
    this.maximumSizeExceeds = true
    this.invalidFileFormat = true
    this.createTrialBalanceTemplate()

  }
  //isHeaderRow = (index: number, row: any) => row.type === 'header';

  TrailBalanceTemplatetest: any[] = [
    { type: 'header', text: 'Total' },
  ];

  displayedColumns3: string[] = ['Allowed Columns', 'CSV Columns'];

  //isDataRow = (index: number, row: any) => row.type === 'data';
  //isHeadRow = (index: number, row: any) => row.type === 'header';


  displayedColumnsImport: string[] = [
    'description',
    'debit',
    'credit',
  ];


  isDataimportRow = (index: number, row: any) => row.type === 'data';
  isHeadimportRow = (index: number, row: any) => row.type === 'header';

  displayedColumnsImportYears: string[] = [
    'accountCode',
    'particulars',

    'unrestrictedDebit',
    'unrestrictedCredit',
    'restrictedDebit',
    'restrictedCredit',
    'endowmentDebit',
    'endowmentCredit',
  ];



  isData2importRow = (index: number, row: any) => row.type === 'data';
  isHead2importRow = (index: number, row: any) => row.type === 'header';

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;


    this.dataSource2.paginator = this.paginator;
    this.dataSource2.sort = this.sort;
  }

  AfterDataMaping() {
    debugger
    //  alert('')
    this.ExcellCalculateTotalcredits_Debits(this.isFundTracking)
    this.onexpclick1()

    this.BindExceldataTotemplate()
    this.ExcellTempGroupData()
    this.errors(this.isFundTracking)


  }


  onexpclick() {
    this.OpenErrors = true;
    this.openImport = false;
  }
  onexpclick1() {
    //  alert('')
    //this.AfterDataMaping()
    this.openImport = true;
    this.OpenErrors = false;
  }
  ClearDropDown(row: any) {
    debugger
    // this.ExcelTrailBalanceTemplate
    this.ExcelTrailBalanceTemplate.filter((excelitem: any) => {
      if (excelitem.DBuniqueAccountsID == row.DBuniqueAccountsID) {
        excelitem.currentPeriodDebit = null;
        excelitem.currentPeriodCredit = null;
        excelitem.openingBalanceDebit = null
        excelitem.openingBalanceCredit = null
        excelitem.currentPeriodDebit = null
        excelitem.currentPeriodCredit = null
        excelitem.unrestrictedDebit = null
        excelitem.unrestrictedCredit = null
        excelitem.restrictedDebit = null
        excelitem.restrictedCredit = null
        excelitem.endowmentDebit = null
        excelitem.endowmentCredit = null
        excelitem.closingBalanceDebit = null
        excelitem.closingBalanceCredit = null
        // excelitem.uniqueAccountsID = 
        excelitem.uniqueAccountsID = -1 * new Date().getTime()

      }
    })
    row.uniqueAccountsID = -1 * new Date().getTime();
    this.BindExceldataTotemplate()
    this.ExcellCalculateTotalcredits_Debits(this.isFundTracking)

  }


  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];


  ifCCorBCCSOFA: boolean = false;

  SOFAformmailtoCC() {
    debugger
    this.ifCCorBCCSOFA = !this.ifCCorBCCSOFA;
    if (!this.ifCCorBCCSOFA) {
      this.TrialBalanceForm.controls['cc'].reset();
      this.TrialBalanceForm.controls['bcc'].reset();
    }
  }

  sendMailTemplate(emailtemplate: any) {
    this.RetriveEmailConfig(emailtemplate)
    //this.dialog.open(emailtemplate, {
    //  width: '50%', maxWidth: '100%', maxHeight: 'auto', height: 'auto', disableClose: true
    //});
  }
  TrialBalanceForm: FormGroup
  createTrialBalanceTemplate() {
    debugger
    this.TrialBalanceForm = this.fb.group({
      emailTemplateId: [0],
      emailType: ['TrialBalance'],
      from: [{ value: this.RetriveEmailConfigdata?.senderEmail, disabled: true }],
      ////pattern for single mail
      ////cc: ['', [Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/)]],
      ////pattern to allow multiple mail id's
      //cc: ['', [Validators.pattern(/^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})(;\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})*$/)]],
      ////bcc: ['', [Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/)]],
      //bcc: ['', [Validators.pattern(/^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})(;\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})*$/)]],
      cc: ['', [Validators.pattern(/^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})(;\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})*$/)]],
      bcc: ['', [Validators.pattern(/^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})(;\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})*$/)]],
      ccCheckbox: [false],
      subject: ['', Validators.required],
      Body: [''],
      charityID: [+localStorage.getItem('charityId')!],
      charityName: [''],
      financialPeriodsID: [localStorage.getItem('currentPeriod')],
      createdby: [localStorage.getItem('userID')],
      modifiedby: [localStorage.getItem('CurrentuserID')],
      centralUserId: [localStorage.getItem('CentralUserId')],
      userId: [localStorage.getItem('userID')],
      fund_Tracking: [localStorage.getItem('fund_Tracking') === 'true'],
      //fund_Tracking:[+localStorage.getItem('fund_Tracking')!],
      to: [
        '',
        [Validators.required, Validators.pattern(/^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})(;\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})*$/)]
      ],
    });
    this.ifCCorBCCSOFA = false
    this.TrialBalanceForm.get('Body')?.valueChanges.subscribe(value => {

      const plainText = value?.replace(/<[^>]*>/g, '') || '';
      if (plainText.length > 2500) {
        const trimmedText = plainText.substring(0, 2500);
        const safeHtml = `<p>${trimmedText}</p>`;
        this.TrialBalanceForm.get('Body')?.setValue(safeHtml, { emitEvent: false });
      }
    });
  }
  GetEmailTemplate() {
    debugger;
    this.Charities_Service.GetEmailTemplate(this.TrialBalanceForm.controls['centralUserId'].value, this.TrialBalanceForm.controls['emailType'].value).subscribe({
      next: (data: any) => {
        debugger;
        if (data.entity != null && data.entity[0].emailTemplateId != null) {
          data.entity[0].body = data.entity[0].body.replace('[UserName]', this.CurrentUserName)
          data.entity[0].subject = data.entity[0].subject.replace('[CharityName]', localStorage.getItem('charity_Name'))
          data.entity[0].charityName = localStorage.getItem('charity_Name')
          data.entity[0].subject = data.entity[0].subject.replace('[CN]', localStorage.getItem('charity_Registration_Number'))
          data.entity[0].body = data.entity[0].body.replace('[CharityName]', localStorage.getItem('charity_Name'))
          data.entity[0].body = data.entity[0].body.replace('[CN]', localStorage.getItem('charity_Registration_Number'))
          this.TrialBalanceForm.patchValue(data.entity[0])
          this.TrialBalanceForm.controls['Body'].setValue(data.entity[0].body)
          this.TrialBalanceForm.controls['userId'].setValue(localStorage.getItem('userID'))
          this.TrialBalanceForm.controls['charityID'].setValue(+localStorage.getItem('charityId')!)
          this.TrialBalanceForm.controls['financialPeriodsID'].setValue(+localStorage.getItem('currentPeriod')!)
          this.TrialBalanceForm.controls['fund_Tracking'].setValue(localStorage.getItem('fund_Tracking') === 'true')
          this.ifCCorBCCSOFA = data.entity[0].ccCheckbox;
        }
        else {
          this.createTrialBalanceTemplate()
        }
        this.TrialBalanceForm.controls['from'].setValue(this.RetriveEmailConfigdata?.senderEmail)
        this.TrialBalanceForm.markAsPristine()
      },
      error: (err) => {
        console.error('Error fetching GetEmailTemplate details:', err);
      }
    });
  }
  RetriveEmailConfigdata: any
  RetriveEmailConfig(emailtemplate?: any) {
    debugger
    var Central_UserId = parseInt(localStorage.getItem('CentralUserId') || '0');
    this.emailConfigService.RetriveEmailConfig(Central_UserId).subscribe((data: BaseEntityModel<Email_Configuration_Model>) => {
      if (data.status === 0) {
        if (data.message == "Successfully, retrieved email server info") {
          if (data.entity != null && data.entity.length > 0) {
            this.RetriveEmailConfigdata = data.entity[0];
            this.TrialBalanceForm.controls['from'].setValue(this.RetriveEmailConfigdata?.senderEmail)
            this.TrialBalanceForm.controls['to'].markAsUntouched()
            this.dialog.open(emailtemplate, {
              width: '50%', maxWidth: '100%', maxHeight: 'auto', height: 'auto', disableClose: true
            });
            this.GetEmailTemplate()
          } else {
            Swal.fire({
              html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Mail Server details not configured!</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Please configure Mail Server setting to send an email.',
              iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
              confirmButtonText: "OK",
              allowOutsideClick: false
            }).then((result) => {
              if (result.value) {
              } else {
                return
              }
            })
            //this.toastr.error(data.message);

          }
        } else {
        }
      } else {
        Swal.fire({
          html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Mail Server details not configured!</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Please configure Mail Server setting to send an email.',
          iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
          confirmButtonText: "OK",
          allowOutsideClick: false
        }).then((result) => {
          if (result.value) {
          } else {
            return
          }
        })
        //t//his.toastr.error(data.message);
      }
    }, (error: HttpErrorResponse) => {
      //this.toastr.error(error.statusText);
    })

  }


  DownLoadSamplefile() {


    if (this.isFundTracking && this.RecandPay == 'Accruals (FRS 102 SORP)') {
      const fileUrl = 'assets/SampleExcells/TrialBalance-With Fund Track.xlsx';
      fetch(fileUrl)
        .then(response => response.blob())
        .then(blob => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'TrialBalance.xlsx';
          link.click();
          window.URL.revokeObjectURL(url);
        });
    } else if (!this.isFundTracking && this.RecandPay == 'Accruals (FRS 102 SORP)') {
      const fileUrl = 'assets/SampleExcells/TrialBalance-Without Fund Track.xlsx';
      fetch(fileUrl)
        .then(response => response.blob())
        .then(blob => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'TrialBalance.xlsx';
          link.click();
          window.URL.revokeObjectURL(url);
        });
    } else if (this.isFundTracking && this.RecandPay == 'Cash (Receipts & Payments)') {
      const fileUrl = 'assets/SampleExcells/TrialBalance-With-FT-and-RP.xlsx';
      fetch(fileUrl)
        .then(response => response.blob())
        .then(blob => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'TrialBalance.xlsx';
          link.click();
          window.URL.revokeObjectURL(url);
        });
    } else if (!this.isFundTracking && this.RecandPay == 'Cash (Receipts & Payments)') {
      const fileUrl = 'assets/SampleExcells/TrialBalance-Without-FT and With-RP.xlsx';
      fetch(fileUrl)
        .then(response => response.blob())
        .then(blob => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'TrialBalance.xlsx';
          link.click();
          window.URL.revokeObjectURL(url);
        });
    }
  }
  ValidtaeExcellFile(selectedFile: any, file: any) {

    var FileType = null

    FileType = this.selectedFileName.split('.')[this.selectedFileName.split('.').length - 1]
    const acceptTypes = [
      'text/csv',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ];
    if (acceptTypes.includes(file.type) || FileType == 'csv' || FileType == 'xlsx') {
      this.selectedFileValid = true
      if (Math.round(file.size / (1024 * 1024)) > 5) {
        this.maximumSizeExceeds = true
        return false;
      }
      else {
        this.maximumSizeExceeds = false
        return true;
      }

    }
    else {
      this.selectedFileValid = false
      return true;
    }
    //if (!this.selectedFileValid) {
    //  Swal.fire({
    //    html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">You have selected Invalid file </h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Please Select a Valid file </p>',

    //    iconHtml: '<span class="fa fa-warning"></span>',
    //    confirmButtonText: "OK",
    //    allowOutsideClick: false
    //  })

    //  return false
    //}
    //else if (Math.round(file.size / 1024 / 1024) > 5) {
    //  Swal.fire({
    //    html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Maximum file size exceeded </h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> File size should not exceeded 5mb </p>',

    //    iconHtml: '<span class="fa fa-warning"></span>',
    //    confirmButtonText: "Ok",
    //    allowOutsideClick: false
    //  })
    //  this.selectedFileValid = false
    //  this.selectedFileName = 'No File Chosen'
    //  this.selectedFile = null
    //  return false
    //}
    //else {return true}
  }
  readFileAndGetJson(event: any) {
    debugger
    this.ExcelTrailBalanceTemplate = JSON.parse(JSON.stringify(this.MainExcelTrailBalanceTemplate))//ExcelTrailBalanceTemplate

    this.ExcellTempGroupData()
    this.ExcellDropDownGroupData()
    this.maximumSizeExceeds = false;
    this.invalidFileFormat = false
    //this.selectedFile = null
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      this.selectedFileName = this.selectedFile.name;
      this.selectedFileSize = Math.round
        (this.selectedFile.size / 1024);

    } else {
      this.selectedFile = null;
      this.selectedFileName = null
      this.selectedFileSize = 0;
    }

    const file = event.target.files[0];
    this.SeletedTeplateData = []
    this.ExcellDropDownData = []

    var Valid = this.ValidtaeExcellFile(this.selectedFile, file)
    if (file && Valid) {

      //csv/xlsx



      const reader = new FileReader();
      reader.onload = (e: any) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];

        var rawData: any = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        this.exceldata = rawData
        if (rawData.length < 2) {
          console.error('Excel file has no data rows');
          return;
        }
        const rows = rawData.slice(1).filter((row: any) => row.some((cell: any) => cell !== undefined && cell !== null));
        var data1: any = null
        var _HeaderName: any = null
        var _AccountId = 0
        //   data1 = rows.reduce((result: any[], row: any, i: number) => {
        //     if ((i > 3 && this.isFundTracking) || (i > 0 && !this.isFundTracking)) {


        //       //const currentRowText = row[1]?.toString().trim();

        //       //const matchedHeader = this.Templateheder.find((header: any) =>
        //       //  //header.headersName === currentRowText?.split(':')[0]
        //       //  header.headersName === currentRowText?.split(':')[1]

        //       //);

        //       //if (matchedHeader) {
        //       //  _HeaderName = currentRowText
        //       //  result.push({////creating Header
        //       //    isHeader: true,
        //       //    headerName: currentRowText,
        //       //    subRows: []
        //       //  });
        //       //}
        ////       else {
        //         if (true) {
        //           _AccountId++;
        //           if (this.isFundTracking) {
        //             if (!Array.isArray(result[result.length - 1])) {
        //               result.push([]);
        //             }
        //             result[result.length - 1].push({////creating Row
        //               ExlAccountId: _AccountId,
        //               accountName: row[1] ,
        //               //headersName: _HeaderName.split(':')[1],

        //               unrestrictedCredit: row[3] == undefined ? null : row[3],
        //               unrestrictedDebit: row[2] == undefined ? null : row[2],

        //               restrictedCredit: row[5] == undefined ? null : row[5],
        //               restrictedDebit: row[4] == undefined ? null : row[4],

        //               endowmentCredit: row[7] == undefined ? null : row[7],
        //               endowmentDebit: row[6] == undefined ? null : row[6],

        //               currentPeriodCredit: 0,
        //               currentPeriodDebit: 0,

        //              // dropDownValue: _HeaderName.split(':')[0] + '-' + currentRowText,
        //               uniqueAccountsID: row[0] == undefined ? null : row[0]

        //             })
        //           }
        //           else {
        //             result[result.length - 1].push({
        //               ExlAccountId: _AccountId,
        //               accountName: row[1] ,
        //              // headersName: _HeaderName.split(':')[1],

        //               unrestrictedCredit: null,
        //               unrestrictedDebit: null,

        //               restrictedCredit: null,
        //               restrictedDebit: null,

        //               endowmentCredit: null,
        //               endowmentDebit: null,
        //              // dropDownValue: _HeaderName.split(':')[1] + '-' + currentRowText,
        //               uniqueAccountsID: row[0] == undefined ? null : row[6],

        //               currentPeriodCredit: row[3] == undefined ? null : row[3],
        //               currentPeriodDebit: row[2] == undefined ? null : row[2]

        //             })
        //           }
        //         }
        //       }
        //   //  }
        //     return result;
        //   }, []);

        data1 = rows.reduce((result: any[], row: any, i: number) => {
          //  if ((i > 3 && this.isFundTracking) || (i > 0 && !this.isFundTracking)) {
          if ((i > 3 && (row[0] ?? row[6]) > 0 && row[1] != undefined && row[1] != '' && row[1] != null)) {
            _AccountId++;
            var mt = row[0] ?? row[6]
            var result2 = []
            const baseRow = {
              ExlAccountId: _AccountId,
              accountName: row[1],
              uniqueAccountsID: row[0] ?? row[6],
              // uniqueAccountsID: result2.length > 0 ? result2[0].UniqCode:-1,
              currentPeriodCredit: this.isFundTracking ? 0 : this.formatToTwoDecimals((row[3]) ?? null),
              currentPeriodDebit: this.isFundTracking ? 0 : this.formatToTwoDecimals((row[2]) ?? null),
              unrestrictedCredit: this.isFundTracking ? this.formatToTwoDecimals((row[3]) ?? null) : null,
              unrestrictedDebit: this.isFundTracking ? this.formatToTwoDecimals((row[2]) ?? null) : null,
              restrictedCredit: this.isFundTracking ? this.formatToTwoDecimals((row[5]) ?? null) : null,
              restrictedDebit: this.isFundTracking ? this.formatToTwoDecimals((row[4]) ?? null) : null,
              endowmentCredit: this.isFundTracking ? this.formatToTwoDecimals((row[7]) ?? null) : null,
              endowmentDebit: this.isFundTracking ? this.formatToTwoDecimals((row[6]) ?? null) : null
            };

            result.push(baseRow)
          }

          return result;
        }, []);




        console.log('Structured Data:', data1);
        this.ResetTotalFeilds();
        // this.ExcellDropDownData = data1.flatMap((header: any) => header.subRows);
        this.ExcellDropDownData = data1
        //  this.SeletedTeplateData = data1.flatMap((header: any) => header.subRows);
        this.SeletedTeplateData = data1

        //  this.ExcellCalculateTotalcredits_Debits(this.isFundTracking)
        this.BindExceldataTotemplate()
        this.ExcellTempGroupData()
        this.errors(this.isFundTracking)
        this.ExcellCalculateTotalcredits_Debits(this.isFundTracking)
      };
      reader.onerror = (error) => {
        console.error('Error reading Excel file:', error);
      };
      reader.readAsArrayBuffer(file);
    }
  }
  formatToTwoDecimals(value: any): any {
    //if (typeof value === 'number' && !Number.isInteger(value)) {
    if (typeof value === 'number') {
      var decimalvalue = parseFloat(value.toFixed(2));
      return decimalvalue.toFixed(2)
    }
    return value;
  }
  FinishExcellImport() {
    debugger
    this.TrailBalanceTemplate.forEach((particulars: any) => {
      if (particulars.type != 'header') {
        var MatchedItem: any = this.ExcelTrailBalanceTemplate.filter((excelitem: any) => excelitem.DBuniqueAccountsID == particulars.uniqueAccountsID)
        if (MatchedItem.length > 0) {
          particulars.unrestrictedCredit = MatchedItem[0].unrestrictedCredit
          particulars.unrestrictedDebit = MatchedItem[0].unrestrictedDebit

          particulars.restrictedCredit = MatchedItem[0].restrictedCredit
          particulars.restrictedDebit = MatchedItem[0].restrictedDebit

          particulars.endowmentCredit = MatchedItem[0].endowmentCredit
          particulars.endowmentDebit = MatchedItem[0].endowmentDebit

          particulars.currentPeriodCredit = MatchedItem[0].currentPeriodCredit
          particulars.currentPeriodDebit = MatchedItem[0].currentPeriodDebit

          /// This feilds will act as previous values for next AP 
          particulars.closingBalanceDebit = this.isFundTracking ? ((+particulars.unrestrictedDebit) + (+particulars.restrictedDebit) + (+particulars.endowmentDebit)) : particulars. currentPeriodDebit
          particulars.closingBalanceCredit = this.isFundTracking ? ((+particulars.restrictedCredit) + (+particulars.unrestrictedCredit) + (+particulars.endowmentCredit)) : particulars.currentPeriodCredit

        }
      }
    })
    this.CalculateTotalcredits_Debits(this.isFundTracking)
    this.selectedFileName = 'No File Chosen'
    this.CloseImport()
    this.msgService.showToastMessage("success", "Trial balance imported successfully");
  }

  hideClose: boolean = false;
  ResetTotalFeilds() {



    this.ExcellTotalDebits = 0
    this.ExcellTotalCredits = 0
    this.ExcellDifference = 0
    this.ExcelTotalUnrestrictedDebit = 0;
    this.ExcelTotalUnrestrictedCredit = 0;
    this.ExcelTotalRestrictedCredit = 0;
    this.ExcelTotalRestrictedDebit = 0;
    this.ExcelTotalEndowmentDebit = 0;
    this.ExcelTotalEndowmentCredit = 0;
    this.ExcelTotalcurrentPeriodDebit = 0;
    this.ExcelTotalcurrentPeriodCredit = 0;
  }
  SetDropExcellDown(ExlAccountId: any, Labledetails: any, LableAccountName?: any, LableHeaderName?: any, SelectedHeaderName?: any) {
    debugger

    var selectedExcelItem = this.ExcellDropDownData.find(item => item.uniqueAccountsID === ExlAccountId);

    var selectedvalue = ExlAccountId.value
    this.ExcelTrailBalanceTemplate.filter((item: any) => {
      if (item.DBuniqueAccountsID == Labledetails.DBuniqueAccountsID) {
        item.uniqueAccountsID = ExlAccountId
      }
    })
    this.BindExceldataTotemplate()
    this.ExcellTempGroupData()
    this.ExcellCalculateTotalcredits_Debits(this.isFundTracking)

    var MatchedItem: any = this.ExcellDropDownData.filter((excelitem: any) => excelitem.uniqueAccountsID == ExlAccountId)
    if (MatchedItem.length > 0 && false) {

      this.SeletedTeplateData.forEach((particulars: any) => {
        if (particulars.uniqueAccountsID === ExlAccountId) {
          particulars.unrestrictedCredit = MatchedItem[0].unrestrictedCredit
          particulars.unrestrictedDebit = MatchedItem[0].unrestrictedDebit

          particulars.restrictedCredit = MatchedItem[0].restrictedCredit
          particulars.restrictedDebit = MatchedItem[0].restrictedDebit

          particulars.endowmentCredit = MatchedItem[0].endowmentCredit
          particulars.endowmentDebit = MatchedItem[0].endowmentDebit

          particulars.currentPeriodCredit = MatchedItem[0].currentPeriodCredit
          particulars.currentPeriodDebit = MatchedItem[0].currentPeriodDebit

        }

      })
      this.BindExceldataTotemplate()
    }

  }
  clearFile() {

    this.selectedFileName = 'No File Chosen';
    this.maximumSizeExceeds = false;
    this.invalidFileFormat = false;
    this.progressExcelLoad = 0;
    this.comapreSize = 0;
    this.exceldata = null;
    this.selectedFileSize = 0;
  }
  BindExceldataTotemplate() {
    debugger

    this.ExcelTrailBalanceTemplate.forEach((particulars: any) => {
      var MatchedItem: any = this.SeletedTeplateData.filter((excelitem: any) => particulars.uniqueAccountsID == excelitem.uniqueAccountsID)
      if (MatchedItem.length > 0) {
        {
          particulars.unrestrictedCredit = MatchedItem[0].unrestrictedCredit
          particulars.unrestrictedDebit = MatchedItem[0].unrestrictedDebit

          particulars.restrictedCredit = MatchedItem[0].restrictedCredit
          particulars.restrictedDebit = MatchedItem[0].restrictedDebit

          particulars.endowmentCredit = MatchedItem[0].endowmentCredit
          particulars.endowmentDebit = MatchedItem[0].endowmentDebit

          particulars.currentPeriodCredit = MatchedItem[0].currentPeriodCredit
          particulars.currentPeriodDebit = MatchedItem[0].currentPeriodDebit

          if (this.isFundTracking) {
            particulars.closingBalanceCredit = (((+particulars.unrestrictedCredit) + (+particulars.restrictedCredit) + (+particulars.endowmentCredit)))
            particulars.closingBalanceDebit = ((+particulars.unrestrictedDebit) + (+particulars.restrictedDebit) + (+particulars.endowmentDebit))
          } else {
            particulars.closingBalanceDebit = (+particulars.currentPeriodDebit)
            particulars.closingBalanceCredit = (+particulars.currentPeriodCredit)
          }

        }
      }
    })

  }

  ExcellCalculateTotalcredits_Debits(IsfundTracking: any) {

    this.ResetTotalFeilds();

    this.ExcelTrailBalanceTemplate.filter((item) => {
      if (IsfundTracking) {
        if (item?.type != "header") {
          var unrestrictedDebit = (+(((typeof (item.unrestrictedDebit) == 'string' && !(+item.unrestrictedDebit > 0)) || item.unrestrictedDebit?.toString().split('.')[0].length > 8) ? 0.00 : item.unrestrictedDebit))
          var unrestrictedCredit = (+(((typeof (item.unrestrictedCredit) == 'string' && !(+item.unrestrictedCredit > 0)) || item.unrestrictedCredit?.toString().split('.')[0].length > 8) ? 0.00 : item.unrestrictedCredit))

          var restrictedCredit = (+(((typeof (item.restrictedCredit) == 'string' && !(+item.restrictedCredit > 0)) || item.restrictedCredit?.toString().split('.')[0].length > 8) ? 0.00 : item.restrictedCredit))
          var restrictedDebit = (+(((typeof (item.restrictedDebit) == 'string' && !(+item.restrictedDebit > 0)) || item.restrictedDebit?.toString().split('.')[0].length > 8) ? 0.00 : item.restrictedDebit))

          var endowmentDebit = (+(((typeof (item.endowmentDebit) == 'string' && !(+item.endowmentDebit > 0)) || item.endowmentDebit?.toString().split('.')[0].length > 8) ? 0.00 : item.endowmentDebit))
          var endowmentCredit = (+(((typeof (item.endowmentCredit) == 'string' && !(+item.endowmentCredit > 0)) || item.endowmentCredit?.toString().split('.')[0].length > 8) ? 0.00 : item.endowmentCredit))

          var ExcellTotalCredits = unrestrictedCredit + restrictedCredit + endowmentCredit
          var ExcellTotalCDebit = unrestrictedDebit + restrictedDebit + endowmentDebit

          this.ExcellTotalCredits += +this.formatToTwoDecimals(ExcellTotalCredits)
          this.ExcellTotalDebits += +this.formatToTwoDecimals(ExcellTotalCDebit)

          this.ExcelTotalUnrestrictedDebit += +this.formatToTwoDecimals(unrestrictedDebit)
          this.ExcelTotalUnrestrictedCredit += +this.formatToTwoDecimals(unrestrictedCredit)

          this.ExcelTotalRestrictedCredit += +this.formatToTwoDecimals(restrictedCredit)
          this.ExcelTotalRestrictedDebit += +this.formatToTwoDecimals(restrictedDebit)

          this.ExcelTotalEndowmentDebit += +this.formatToTwoDecimals(endowmentDebit)
          this.ExcelTotalEndowmentCredit += +this.formatToTwoDecimals(endowmentCredit)
        }
      }
      else {
        if (item?.type != "header") {

          var currentPeriodCredit = (+(((typeof (item.currentPeriodCredit) == 'string' && !(+item.currentPeriodCredit > 0)) || item.currentPeriodCredit?.toString().split('.')[0].length > 8) ? 0.00 : item.currentPeriodCredit))
          var currentPeriodDebit = (+(((typeof (item.currentPeriodDebit) == 'string' && !(+item.currentPeriodDebit > 0)) || item.currentPeriodDebit?.toString().split('.')[0].length > 8) ? 0.00 : item.currentPeriodDebit))

          this.ExcellTotalCredits += (+currentPeriodCredit)
          this.ExcellTotalDebits += (+currentPeriodDebit)



          this.ExcelTotalcurrentPeriodDebit += (+currentPeriodDebit)
          this.ExcelTotalcurrentPeriodCredit += (+currentPeriodCredit)
        }
      }
    })
    this.ExcellTotalCredits = +this.formatToTwoDecimals(this.ExcellTotalCredits);
    this.ExcellTotalDebits = +this.formatToTwoDecimals(this.ExcellTotalDebits);

    this.ExcelTotalUnrestrictedDebit = +this.formatToTwoDecimals(this.ExcelTotalUnrestrictedDebit);
    this.ExcelTotalUnrestrictedCredit = +this.formatToTwoDecimals(this.ExcelTotalUnrestrictedCredit);

    this.ExcelTotalRestrictedCredit = +this.formatToTwoDecimals(this.ExcelTotalRestrictedCredit);
    this.ExcelTotalRestrictedDebit = +this.formatToTwoDecimals(this.ExcelTotalRestrictedDebit);

    this.ExcelTotalEndowmentDebit = +this.formatToTwoDecimals(this.ExcelTotalEndowmentDebit);
    this.ExcelTotalEndowmentCredit = +this.formatToTwoDecimals(this.ExcelTotalEndowmentCredit);

    this.ExcelTotalcurrentPeriodDebit = +this.formatToTwoDecimals(this.ExcelTotalcurrentPeriodDebit);
    this.ExcelTotalcurrentPeriodCredit = +this.formatToTwoDecimals(this.ExcelTotalcurrentPeriodCredit);

    this.ExcellDifference = this.ExcelTotalcurrentPeriodDebit - this.ExcelTotalcurrentPeriodCredit
    this.errors(IsfundTracking);
  }

  onFundTrackingChange(event: any) {

    if (event.target.value == false) {
      event.target.value = true
      this.isFundTracking = true
      // alert(true)
    }
  }
  modalImport(importTrial: any) {

    this.progressExcelLoad = 0
    this.comapreSize = 0
    this.ExcellDropDownGroupData()
    this.ExcellTempGroupData()
    let dialogRef = this.dialog.open(importTrial, {
      width: '70%', maxWidth: '100%', height: 'auto', disableClose: true
    });
    this.selectedFileName = 'No File Chosen'
    this.SetExcelTrailBalanceColumns()
  }
  CloseImport(importTrial?: any) {

    if (this.selectedFileName != 'No File Chosen') {
      Swal.fire({

        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',

        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      })
        .then((result) => {
          if (result.isConfirmed) {
            debugger
            this.datashare.setisdirty(false)
            this.isdirty = false
            this.selectedFileSize = 0;
            this.dialog.closeAll();
            this.ExcelTrailBalanceTemplate = JSON.parse(JSON.stringify(this.MainExcelTrailBalanceTemplate))
          }

        });
    } else {
      this.dialog.closeAll();
    }
  }

  ExcelCurrentPeriod_Calculation(event: any, HeadersID: any, uniqueAccountsID: any, Nature: any, AccountCode: any) {

    this.ExcellTotalCredits = 0
    this.ExcellTotalDebits = 0
    this.ExcellDifference = 0

    this.ResetTotalFeilds();
    this.ExcelTrailBalanceTemplate.filter((item) => {
      if (item?.type != "header") {

        if (item.uniqueAccountsID == uniqueAccountsID && Nature == 'Credit') {
          item.currentPeriodCredit = (+event.target.value)
          item.currentPeriodDebit = event.target.value != '' ? null : item.currentPeriodDebit


        }
        if (item.uniqueAccountsID == uniqueAccountsID && Nature == 'Debit') {
          item.currentPeriodDebit = (+event.target.value)
          item.currentPeriodCredit = event.target.value != '' ? null : item.currentPeriodCredit
        }
        var currentPeriodCredit = ((typeof (item.currentPeriodCredit) == 'string' ? 0.00 : item.currentPeriodCredit))
        var currentPeriodDebit = ((typeof (item.currentPeriodDebit) == 'string' ? 0.00 : item.currentPeriodDebit))

        item.closingBalanceCredit = ((+currentPeriodCredit))
        item.closingBalanceDebit = ((+currentPeriodDebit))

        //this.ExcellTotalCredits += (+(typeof (item.currentPeriodCredit) == 'string' ? 0.00 : item.currentPeriodCredit))
        //this.ExcellTotalDebits += (+(typeof (item.currentPeriodDebit) == 'string' ? 0.00 : item.currentPeriodDebit))

        //this.ExcelTotalUnrestrictedDebit += item.unrestrictedDebit?.toString().split('.')[0].length > 8 ? 0 : item.unrestrictedDebit;
        //this.ExcelTotalUnrestrictedCredit += item.unrestrictedCredit?.toString().split('.')[0].length > 8 ? 0 : item.unrestrictedCredit;
        //this.ExcelTotalRestrictedCredit += item.restrictedCredit?.toString().split('.')[0].length > 8 ? 0 : item.restrictedCredit;
        //this.ExcelTotalRestrictedDebit += item.restrictedDebit?.toString().split('.')[0].length > 8 ? 0 : item.restrictedDebit;

        //this.ExcelTotalEndowmentDebit += item.endowmentDebit?.toString().split('.')[0].length > 8 ? 0 : item.endowmentDebit;
        //this.ExcelTotalEndowmentCredit += item.endowmentCredit?.toString().split('.')[0].length > 8 ? 0 : item.endowmentCredit;

        //this.ExcelTotalcurrentPeriodDebit += (+(typeof (item.currentPeriodDebit) == 'string' || item.currentPeriodDebit?.toString().split('.')[0].length > 8 ? 0.00 : item.currentPeriodDebit))
        //this.ExcelTotalcurrentPeriodCredit += (+(typeof (item.currentPeriodCredit) == 'string' || item.currentPeriodCredit?.toString().split('.')[0].length > 8 ? 0.00 : item.currentPeriodCredit))
      }
    })
    this.ExcellCalculateTotalcredits_Debits(this.isFundTracking)
    event.target.value = event.target.value == '' ? null : event.target.value
    this.ExcellDifference = (this.ExcelTotalcurrentPeriodCredit - this.ExcelTotalcurrentPeriodDebit)
    this.errors(false);

  }
  ExcelCurrentPeriod_Calculation_FT(event: any, HeadersID: any, uniqueAccountsID: any, Nature: any, AccountCode: any, Type: any) {
    debugger
    debugger
    this.ExcellTotalCredits = 0
    this.ExcellTotalDebits = 0
    this.ExcellDifference = 0
    this.ExcelTotalUnrestrictedDebit = 0;
    this.ExcelTotalUnrestrictedCredit = 0;
    this.ExcelTotalRestrictedCredit = 0;
    this.ExcelTotalRestrictedDebit = 0;
    this.ExcelTotalEndowmentDebit = 0;
    this.ExcelTotalEndowmentCredit = 0;
    this.ExcelTotalcurrentPeriodDebit = 0
    this.ExcelTotalcurrentPeriodCredit = 0
    if (Type == 'Unrestricted') {
      this.ExcelTrailBalanceTemplate.filter((item) => {
        if (item?.type != "header") {


          if (item.uniqueAccountsID == uniqueAccountsID && Nature == 'Credit') {

            item.unrestrictedCredit = (+event.target.value)
            item.unrestrictedDebit = event.target.value != '' ? null : item.unrestrictedDebit
            //item.closingBalanceCredit = ((+unrestrictedCredit) + (+item.restrictedCredit) + (+item.endowmentCredit))

          }
          if (item.uniqueAccountsID == uniqueAccountsID && Nature == 'Debit') {

            item.unrestrictedDebit = (+event.target.value)
            item.unrestrictedCredit = event.target.value != '' ? null : item.unrestrictedCredit
          }
          var unrestrictedCredit = ((typeof (item.unrestrictedCredit) == 'string' ? 0.00 : item.unrestrictedCredit))
          var unrestrictedDebit = ((typeof (item.unrestrictedDebit) == 'string' ? 0.00 : item.unrestrictedDebit))

          item.closingBalanceDebit = ((+unrestrictedDebit) + (+item.restrictedDebit) + (+item.endowmentDebit))
          item.closingBalanceCredit = ((+unrestrictedCredit) + (+item.restrictedCredit) + (+item.endowmentCredit))
          this.ExcellTotalCredits += ((+unrestrictedCredit) + (+item.restrictedCredit) + (+item.endowmentCredit))
          this.ExcellTotalDebits += ((+unrestrictedDebit) + (+item.restrictedDebit) + (+item.endowmentDebit))
        }
      })
    }
    else if (Type == 'Restricted') {
      this.ExcelTrailBalanceTemplate.filter((item) => {
        if (item?.type != "header") {

          if (item.uniqueAccountsID == uniqueAccountsID && Nature == 'Credit') {

            item.restrictedCredit = (+event.target.value)
            item.restrictedDebit = event.target.value != '' ? null : item.restrictedDebit
            //this.ExcelTotalUnrestrictedCredit = (+item.restrictedCredit)


          }

          if (item.uniqueAccountsID == uniqueAccountsID && Nature == 'Debit') {
            item.restrictedDebit = (+event.target.value)
            item.restrictedCredit = event.target.value != '' ? null : item.restrictedCredit
          }
          var restrictedCredit = ((typeof (item.restrictedCredit) == 'string' ? 0.00 : item.restrictedCredit))
          var restrictedDebit = ((typeof (item.restrictedDebit) == 'string' ? 0.00 : item.restrictedDebit))

          item.closingBalanceDebit = ((+item.unrestrictedDebit) + (+item.restrictedDebit) + (+item.endowmentDebit))
          item.closingBalanceCredit = ((+item.restrictedCredit) + (+item.unrestrictedCredit) + (+item.endowmentCredit))

          this.ExcellTotalCredits += ((+item.restrictedCredit) + (+item.restrictedCredit) + (+item.endowmentCredit))
          this.ExcellTotalDebits += ((+item.unrestrictedDebit) + (+item.restrictedDebit) + (+item.endowmentDebit))

        }

      })

    }

    else if (Type == 'Endowment') {

      this.ExcelTrailBalanceTemplate.filter((item) => {

        if (item?.type != "header") {

          if (item.uniqueAccountsID == uniqueAccountsID && Nature == 'Credit') {


            item.endowmentCredit = (+event.target.value)
            item.endowmentDebit = event.target.value != '' ? null : item.endowmentDebit
            //this.ExcelTotalEndowmentCredit = (+item.endowmentCredit)

          }

          if (item.uniqueAccountsID == uniqueAccountsID && Nature == 'Debit') {

            item.endowmentDebit = (+event.target.value)
            item.endowmentCredit = event.target.value != '' ? null : item.endowmentCredit
          }
          var endowmentCredit = ((typeof (item.endowmentCredit) == 'string' ? 0.00 : item.endowmentCredit))
          var endowmentDebit = ((typeof (item.endowmentDebit) == 'string' ? 0.00 : item.endowmentDebit))

          item.closingBalanceDebit = ((+item.unrestrictedDebit) + (+item.restrictedDebit) + (+endowmentDebit))
          item.closingBalanceCredit = ((+item.unrestrictedCredit) + (+item.restrictedCredit) + (+endowmentCredit))

          this.ExcellTotalCredits += ((+item.unrestrictedCredit) + (+item.restrictedCredit) + (+endowmentCredit))
          this.ExcellTotalDebits += ((+item.unrestrictedDebit) + (+item.restrictedDebit) + (+item.endowmentDebit))

        }

      })

    }
    this.ExcellCalculateTotalcredits_Debits(this.isFundTracking)
    event.target.value = event.target.value == '' ? null : event.target.value
    this.ExcellDifference = (this.ExcellTotalCredits - this.ExcellTotalDebits)
    this.errors(true);

  }
  splitDecimalLength(Amount: any) {
    const value = Amount?.toString();
    const [intPart = '', decPart = ''] = value?.split('.') ?? [];
    return intPart.length;
  }
  isDragging = false;
  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.isDragging = true;
  }
  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false;
  }
  onFileDrop(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false;

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.readFileAndGetJson({ target: { files } });
    }
  }
  errorLogs: any = []
  errorsCount: any
  errors(IsfundTracking: any) {
    //alert('')
    debugger

    this.errorLogs = []
    this.ExcelTrailBalanceTemplate.forEach((item: any) => {
      if (IsfundTracking) {
        if (item?.type != "header") {
          if (item.unrestrictedCredit?.toString().split('.')[0].length > 8 || (typeof (item.unrestrictedCredit) != 'number' && item.unrestrictedCredit != "" && item.unrestrictedCredit != null && isNaN(item.unrestrictedCredit))) {
            this.errorLogs.push({ filedName: item.accountName, fieldValue: item.unrestrictedCredit, reason: (typeof (item.unrestrictedCredit) != 'number' && item.unrestrictedCredit != "" && item.unrestrictedCredit != null) && !(item.unrestrictedCredit?.toString().split('.')[0].length > 8) ? 'Invalid format.' : 'Maximum character limit of 8 has been exceeded', columnName: 'Unrestricted Credit' })
          }
          if (item.unrestrictedDebit?.toString().split('.')[0].length > 8 || (typeof (item.unrestrictedDebit) != 'number' && item.unrestrictedDebit != "" && item.unrestrictedDebit != null) && isNaN(item.unrestrictedDebit)) {
            this.errorLogs.push({ filedName: item.accountName, fieldValue: item.unrestrictedDebit, reason: (typeof (item.unrestrictedDebit) != 'number' && item.unrestrictedDebit != "" && item.unrestrictedDebit != null) && !(item.unrestrictedDebit?.toString().split('.')[0].length > 8) ? 'Invalid format.' : 'Maximum character limit of 8 has been exceeded', columnName: 'Unrestricted Debit' })
          }
          if (item.restrictedCredit?.toString().split('.')[0].length > 8 || (typeof (item.restrictedCredit) != 'number' && item.restrictedCredit != "" && item.restrictedCredit != null) && isNaN(item.restrictedCredit)) {
            this.errorLogs.push({ filedName: item.accountName, fieldValue: item.restrictedCredit, reason: (typeof (item.restrictedCredit) != 'number' && item.restrictedCredit != "" && item.restrictedCredit != null) && !(item.restrictedCredit?.toString().split('.')[0].length > 8) ? 'Invalid format.' : 'Maximum character limit of 8 has been exceeded', columnName: 'Restricted Credit' })
          }
          if (item.restrictedDebit?.toString().split('.')[0].length > 8 || (typeof (item.restrictedDebit) != 'number' && item.restrictedDebit != "" && item.restrictedDebit != null) && isNaN(item.restrictedDebit)) {
            this.errorLogs.push({ filedName: item.accountName, fieldValue: item.restrictedDebit, reason: (typeof (item.restrictedDebit) != 'number' && item.restrictedDebit != "" && item.restrictedDebit != null) && !(item.restrictedDebit?.toString().split('.')[0].length > 8) ? 'Invalid format.' : 'Maximum character limit of 8 has been exceeded', columnName: 'Restricted Debit' })
          }
          if (item.endowmentCredit?.toString().split('.')[0].length > 8 || (typeof (item.endowmentCredit) != 'number' && item.endowmentCredit != "" && item.endowmentCredit != null) && isNaN(item.endowmentCredit)) {
            this.errorLogs.push({ filedName: item.accountName, fieldValue: item.endowmentCredit, reason: (typeof (item.endowmentCredit) != 'number' && item.endowmentCredit != "" && item.endowmentCredit != null) && !(item.endowmentCredit?.toString().split('.')[0].length > 8) ? 'Invalid format.' : 'Maximum character limit of 8 has been exceeded', columnName: 'Endowment Credit' })
          }
          if (item.endowmentDebit?.toString().split('.')[0].length > 8 || (typeof (item.endowmentDebit) != 'number' && item.endowmentDebit != "" && item.endowmentDebit != null) && isNaN(item.endowmentDebit)) {
            this.errorLogs.push({ filedName: item.accountName, fieldValue: item.endowmentDebit, reason: (typeof (item.endowmentDebit) != 'number' && item.endowmentDebit != "" && item.endowmentDebit != null) && !(item.endowmentDebit?.toString().split('.')[0].length > 8) ? 'Invalid format.' : 'Maximum character limit of 8 has been exceeded', columnName: 'Endowment Debit' })
          }
          if ((item.unrestrictedCredit != null && item.unrestrictedCredit != '' && item.unrestrictedCredit.toString().trim() != '') && (item.unrestrictedDebit != null && item.unrestrictedDebit != '' && item.unrestrictedDebit.toString().trim()  != '')) {
            debugger
            this.errorLogs.push({ filedName: item.accountName, fieldValue: item.unrestrictedDebit, reason: 'Either credit or debit only acceptable.', columnName: 'Unrestricted Debit' })
            this.errorLogs.push({ filedName: item.accountName, fieldValue: item.unrestrictedCredit, reason: 'Either credit or debit only acceptable.', columnName: 'Unrestricted Credit' })
          }
          if ((item.restrictedCredit != null && item.restrictedCredit.toString().trim() != '') && (item.restrictedDebit != null && item.restrictedDebit.toString().trim() != '')) {
            this.errorLogs.push({ filedName: item.accountName, fieldValue: item.restrictedDebit, reason: 'Either credit or debit only acceptable.', columnName: 'Restricted Debit' })
            this.errorLogs.push({ filedName: item.accountName, fieldValue: item.restrictedCredit, reason: 'Either credit or debit only acceptable.', columnName: 'Restricted Credit' })
          }
          if ((item.endowmentCredit != null && item.endowmentCredit.toString().trim() != '') && (item.endowmentDebit != null && item.endowmentDebit.toString().trim() != '')) {
            this.errorLogs.push({ filedName: item.accountName, fieldValue: item.endowmentDebit, reason: 'Either credit or debit only acceptable.', columnName: 'Endowment Debit' })
            this.errorLogs.push({ filedName: item.accountName, fieldValue: item.endowmentCredit, reason: 'Either credit or debit only acceptable.', columnName: 'Endowment Credit' })
          }
        }
      }

      else {
        if (item?.type != "header") {
          if (item.currentPeriodDebit?.toString().split('.')[0].length > 8 || (typeof (item.currentPeriodDebit) != 'number' && item.currentPeriodDebit != "" && item.currentPeriodDebit != null && isNaN(item.currentPeriodDebit))) {
            this.errorLogs.push({ filedName: item.accountName, fieldValue: item.currentPeriodDebit, reason: (typeof (item.currentPeriodDebit) != 'number' && item.currentPeriodDebit != "" && item.currentPeriodDebit != null) && !(item.currentPeriodDebit?.toString().split('.')[0].length > 8) ? 'Invalid format.' : 'Maximum character limit of 8 has been exceeded', columnName: 'Current Debit' })

          }

          if (item.currentPeriodCredit?.toString().split('.')[0].length > 8 || (typeof (item.currentPeriodCredit) != 'number' && item.currentPeriodCredit != "" && item.currentPeriodCredit != null) && isNaN(item.currentPeriodCredit)) {
            this.errorLogs.push({ filedName: item.accountName, fieldValue: item.currentPeriodCredit, reason: (typeof (item.currentPeriodCredit) != 'number' && item.currentPeriodCredit != "" && item.currentPeriodCredit != null) && !(item.currentPeriodCredit?.toString().split('.')[0].length > 8) ? 'Invalid format.' : 'Maximum character limit of 8 has been exceeded', columnName: 'Current Credit' })

          }
          if ((item.currentPeriodDebit) != null && (item.currentPeriodCredit) != null && (item.currentPeriodCredit.toString().trim()) != '' && (item.currentPeriodDebit.toString().trim()) != '') {
            this.errorLogs.push({ filedName: item.accountName, fieldValue: item.currentPeriodDebit, reason: 'Either credit or debit only acceptable.', columnName: 'Current Debit' })
            this.errorLogs.push({ filedName: item.accountName, fieldValue: item.currentPeriodCredit, reason: 'Either credit or debit only acceptable.', columnName: 'Current Credit' })
          }
          //this.ExcellTotalCredits += (+item.currentPeriodCredit)
          //this.ExcellTotalDebits += (+item.currentPeriodDebit)
        }
      }
    })
    this.errorsCount = this.errorLogs.length
  }
  limitDecimal(event: any) {
    let value = event.target.value;
    // Allow only up to 5 digits before decimal and 2 after (example)
    const regex = /^\d{0,8}?$/;
    if (!regex.test(value)) {
      value = value.slice(0, -1);
    }
    event.target.value = value;
  }

  displayedColumnsUpdatedTrial: string[] = [];
  displayedExcelColumnsUpdatedTrial: string[] = [];
  groupedData: any[] = [];
  ExcellDropDowngroupedData: any[] = [];
  ExcellTempgroupedData: any[] = [];


  backToCharityOverView() {

    // this.spinner.show()
    localStorage.setItem('isFromBasicInfo', 'true')
    //localStorage.setItem('IsFromSwitchCharity', 'false')
    this.router.navigate(['/charity'])

  }
  BackToBasicInfo() {


    this.router.navigate(['/basicinformation']);
  }
  SaveTrailbalance(value?: any) {
    debugger

    if (
      (((this.getAbsoluteDifference(this.TotalUnrestrictedCredit, this.TotalUnrestrictedDebit) != 0) || (this.getAbsoluteDifference(this.TotalRestrictedDebit, this.TotalRestrictedCredit) != 0) || (this.getAbsoluteDifference(this.TotalEndowmentDebit, this.TotalEndowmentCredit) != 0)) && this.isFundTracking)
      ||
      ((!this.isFundTracking) && ((this.getAbsoluteDifference(this.TotalcurrentPeriodCredit, this.TotalcurrentPeriodDebit) != 0)))
    ) {
      Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Trial Balance is not balanced!</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Balance the difference of &pound' + ((this.getAbsoluteDifference(this.TotalUnrestrictedCredit, this.TotalUnrestrictedDebit)) + (this.getAbsoluteDifference(this.TotalRestrictedDebit, this.TotalRestrictedCredit)) + (this.getAbsoluteDifference(this.TotalEndowmentDebit, this.TotalEndowmentCredit)) + this.getAbsoluteDifference(this.TotalcurrentPeriodCredit, this.TotalcurrentPeriodDebit)) + ' to continue',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      }).then((result) => {
        return
      })
    }
    else {
      var _TrailBalanceTemplate = this.TrailBalanceTemplate.filter(account => (account.type != 'header'))
      _TrailBalanceTemplate.forEach(x => {
        x.save_Type = 'SaveAndNext'
      })
      this.DisableSavebtn = true
      this.trailBalanceService.SaveTrailbalance(_TrailBalanceTemplate).subscribe((Response: any) => {
        this.DisableSavebtn = false
        this.datashare.setisdirty(false)
        this.isdirty = false
        if (this.Difference == 0) {
          /* if (this.Basicinfodata[0].accounting_Method == "Receipts & Payments")*/
          if (
            this.Basicinfodata[0].accounting_Method == "Receipts & Payments" ||
            this.Basicinfodata[0].accounting_Method == "Cash (Receipts & Payments)"
          ) {
            this.DBTotalCredits = 0
            this.TotalCredits = 0
            this.DBTotalDebits = 0
            this.TotalDebits = 0
            this.router.navigate(['/receiptsandpayments']);
            if (value == 'Save') {
              this.msgService.showToastMessage("success", "Trial Balance is saved successfully");
            } else {
              this.msgService.showToastMessage("success", "Trial Balance is updated successfully");
            }
          } else if (this.Basicinfodata[0].accounting_Method == "Accruals (FRS 102 SORP)") {
            this.DBTotalCredits = 0
            this.TotalCredits = 0
            this.DBTotalDebits = 0
            this.TotalDebits = 0
            this.router.navigate(['/financialactivities']);

            if (this.apFinalised == false) { 
            if (value == 'Save') {
              this.msgService.showToastMessage("success", "Trial Balance is saved successfully");
            } else {
              this.msgService.showToastMessage("success", "Trial Balance is updated successfully");
            }
          }
          }
        } else {
        }
      })
    }
  }
  SaveasDraft() {

    // this.spinner.show()
    //this.router.navigate(['/charity']);
    var _TrailBalanceTemplate = this.TrailBalanceTemplate.filter(account => (account.type != 'header'))

    if (
      (((this.getAbsoluteDifference(this.TotalUnrestrictedCredit, this.TotalUnrestrictedDebit) != 0) || (this.getAbsoluteDifference(this.TotalRestrictedDebit, this.TotalRestrictedCredit) != 0) || (this.getAbsoluteDifference(this.TotalEndowmentDebit, this.TotalEndowmentCredit) != 0)) && (this.isFundTracking))
      ||
      ((this.getAbsoluteDifference(this.TotalcurrentPeriodDebit, this.TotalcurrentPeriodCredit) != 0) && !this.isFundTracking)
    ) {
      Swal.fire({

        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Trial Balance is not balanced!</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Do you want to Save as Draft?</p>',

        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {

          _TrailBalanceTemplate.forEach(x => {
            x.save_Type = 'SaveAsDraft'
          })
          this.DisableSavebtn = true

          this.trailBalanceService.SaveTrailbalance(_TrailBalanceTemplate).subscribe((Response: any) => {
            this.DisableSavebtn = false
            this.DisableSavebtn = false
            this.datashare.setisdirty(false)

            this.DBTotalCredits = 0
            this.TotalCredits = 0
            this.DBTotalDebits = 0
            this.TotalDebits = 0
            localStorage.setItem('isFromBasicInfo', 'true')
            this.router.navigate(['/charity']);
            if (this.apFinalised == false) {
              this.msgService.showToastMessage("success", "Trial Balance has been saved as draft successfully ")
            }
          })
          //this.router.navigate(['/charity']);

          return
        }

        else {

          return
        }
        this.SaveasDraft()
        {
          console.log("Save as Draft clicked!")
        }

      })
    }
    else {


      var _TrailBalanceTemplate = this.TrailBalanceTemplate.filter(account => (account.type != 'header'))
      _TrailBalanceTemplate.forEach(x => {
        x.save_Type = 'SaveAsDraft'
      })
      this.DisableSavebtn = true

      this.trailBalanceService.SaveTrailbalance(_TrailBalanceTemplate).subscribe((Response: any) => {
        this.DisableSavebtn = false
        this.datashare.setisdirty(false)
        this.isdirty = false
        if (this.Difference == 0) {

          this.DBTotalCredits = 0
          this.TotalCredits = 0
          this.DBTotalDebits = 0
          this.TotalDebits = 0
          localStorage.setItem('isFromBasicInfo', 'true')
          this.router.navigate(['/charity']);
          if (this.apFinalised == false) {
            this.msgService.showToastMessage("success", "Trial Balance has been saved as draft successfully ")
          }
        }
        else {


        }
      })
    }
  }
  ExcellTempGroupData() {
    this.ExcellTempgroupedData = []
    let currentGroup: any = null;
    this.ExcelTrailBalanceTemplate.forEach(item => {
      if (item.type === 'header') {
        if (currentGroup) {
          this.ExcellTempgroupedData.push(currentGroup);
        }
        currentGroup = {
          header: item,
          data: [],
          expanded: false // Initially collapsed
        };
      }
      //  else if (item.type === 'Subheader' || item.type === 'Subheader1' || item.type === 'Account' && currentGroup) {
      //  currentGroup.data.push(item);
      //}
          else if (
          ((item.type === 'Subheader' || item.type === 'Subheader1' || item.type === 'Account' && currentGroup) && (item.accountName != 'Current Assets - Debtors more than one Year' && this.RecandPay == 'Cash (Receipts & Payments)'))
          || (((item.type === 'Subheader' || item.type === 'Subheader1' || item.type === 'Account' && currentGroup) && (this.RecandPay != 'Cash (Receipts & Payments)')))) {
          currentGroup.data.push(item);
        }
    });
    // Don't forget the last group
    if (currentGroup) {
      this.ExcellTempgroupedData.push(currentGroup);
    }
  }
  ExcellDropDownGroupData() {
    this.ExcellDropDowngroupedData = []
    let currentGroup: any = null;
    this.ExcelTrailBalanceTemplate.forEach(item => {
      if (item.type === 'header') {
        if (currentGroup) {
          this.ExcellDropDowngroupedData.push(currentGroup);
        }
        currentGroup = {
          header: item,
          data: [],
          expanded: false // Initially collapsed
        };
      }
      //else if (item.type === 'Subheader' || item.type === 'Subheader1' || item.type === 'Account' && currentGroup) {
      //  currentGroup.data.push(item);
      //}
      else if (
        ((item.type === 'Subheader' || item.type === 'Subheader1' || item.type === 'Account' && currentGroup) && (item.accountName != 'Current Assets - Debtors more than one Year' && this.RecandPay == 'Cash (Receipts & Payments)'))
        || (((item.type === 'Subheader' || item.type === 'Subheader1' || item.type === 'Account' && currentGroup) && (this.RecandPay != 'Cash (Receipts & Payments)')))) {
        currentGroup.data.push(item);
      }
    });
    // Don't forget the last group
    if (currentGroup) {
      this.ExcellDropDowngroupedData.push(currentGroup);
    }
  }
  GroupData() {
    debugger
    this.groupedData = []
    let currentGroup: any = null;
    this.TrailBalanceTemplate.forEach(item => {
      if (item.type === 'header') {
        if (currentGroup) {
          this.groupedData.push(currentGroup);
        }
        currentGroup = {
          header: item,
          data: [],
          expanded: false, // Initially collapsed
          showHeaer:true
        };
      }
      else if (
        ((item.type === 'Subheader' || item.type === 'Subheader1' || item.type === 'Account' && currentGroup) && (item.accountName != 'Current Assets - Debtors more than one Year' && this.RecandPay == 'Cash (Receipts & Payments)'))
        || (((item.type === 'Subheader' || item.type === 'Subheader1' || item.type === 'Account' && currentGroup) && (this.RecandPay != 'Cash (Receipts & Payments)')))) {
        currentGroup.data.push(item);
      }
    });
    // Don't forget the last group
    if (currentGroup) {
      this.groupedData.push(currentGroup);
    }
  }
  //toggleGroup(index: number) {
  //  debugger
  //  //this.GroupData()
  //  this.ShowSpinner = true;
  //  this.groupedData.filter((tab, i) => { if (i != index) { tab.expanded = false } })
  //  this.groupedData[index].expanded = !this.groupedData[index].expanded;
  //}
  toggleGroup(index: number) {
    debugger
    this.ShowSpinner = true;

    setTimeout(() => {
      this.groupedData.forEach((tab, i) => {
        tab.expanded = i === index? !tab.expanded : false;
      });

      this.ShowSpinner = false;
    }, 500); // Adjust delay as needed
  }
  searchAccounts(search?: any) { 
    debugger
    this.noRecordsfound = true
    this.groupedData.filter((tab, i) => {
   
      var header:any = null
      var subHeader: any = null
      var subHeader1: any = null
      tab.showHeaer = false
     // if (tab.expanded == true) {
      if (true) {
        const term = this.searchTerm?.toLowerCase().trim();
        tab.data.forEach((record: any, index: any) => {
          record.display = false
          if (term != '') {
          
            if (record.dataType == "Header") { header = index }
            if (record.dataType == "Subheader") { subHeader = index }
            if (record.dataType == "Subheader1") { subHeader1 = index }
            if (record.accountName?.toLowerCase().includes(term) && record.dataType == "Data") {
              debugger
              this.noRecordsfound = false
              tab.showHeaer = true
              record.display = true
              if (header)
                tab.data[header].display = true
              if (subHeader)
                tab.data[subHeader].display = true
              if (subHeader1)
                tab.data[subHeader1].display = true

            }
          } else {
            record.display = true
            tab.showHeaer = true
            this.noRecordsfound = false
          }
        })
      }
    })
  }
  ExcellDropDowntoggleGroup(index: number) {

    //this.GroupData()
    this.ExcellDropDowngroupedData.filter((tab, i) => { if (i != index) { tab.expanded = false } })
    this.ExcellDropDowngroupedData[index].expanded = !this.ExcellDropDowngroupedData[index].expanded;
  }
  ExcellMaptoggleGroup(index: number) {
    debugger
    //this.GroupData()
    this.ExcellTempgroupedData.filter((tab, i) => { if (i != index) { tab.expanded = false } })
    this.ExcellTempgroupedData[index].expanded = !this.ExcellTempgroupedData[index].expanded;
  }
  SetExcelTrailBalanceColumns() {


    this.displayedExcelColumnsUpdatedTrial = [
      ...(this.isFundTracking
        ? [
          'unrestrictedDebit',
          'unrestrictedCredit',
          'restrictedDebit',
          'restrictedCredit',
          'endowmentDebit',
          'endowmentCredit'
        ]
        : [
          'currentPeriodCredit',
          'currentPeriodDebit'
        ]
      ),
    ];
  }
  SetTrailBalanceColumns() {


    this.displayedColumnsUpdatedTrial = [
      ...(this.isFundTracking
        ? [
          'unrestrictedDebit',
          'unrestrictedCredit',
          'restrictedDebit',
          'restrictedCredit',
          'endowmentDebit',
          'endowmentCredit'
        ]
        : [
          'currentPeriodDebit',
          'currentPeriodCredit'

        ]
      ),
      ...(this.Basicinfodata[0]?.withPrevoiusPeriod
        ? [
          'openingBalanceDebit',
          'openingBalanceCredit'
        ]
        : []
      )
    ];
  }
  getColumnDisplayName(column: string): string {
    const displayNames: { [key: string]: string } = {
      'unrestrictedDebit': 'Unrestricted Debit (£)',
      'unrestrictedCredit': 'Unrestricted Credit (£)',
      'restrictedDebit': 'Restricted Debit (£)',
      'restrictedCredit': 'Restricted Credit (£)',
      'endowmentDebit': 'Endowment Debit (£)',
      'endowmentCredit': 'Endowment Credit (£)',
      'openingBalanceDebit': 'Debit (£)',
      'openingBalanceCredit': 'Credit (£)',
      'currentPeriodCredit': 'Credit (£)',
      'currentPeriodDebit': 'Debit (£)'
    };
    return displayNames[column] || column;
  }
  GetUserAccess() {
    this._UsermanagementService.GetUserRoleAccess(localStorage['userID']).subscribe(data => {
      debugger
      if (data.entity.length) {
        this.UserRoleAccess = data.entity[0]
        var submitedDate = this.UserRoleAccess.currentAPSubmitDate
      }
    });
  }
  getExcelColumnDisplayName(column: string): string {
    const displayNames: { [key: string]: string } = {
      'unrestrictedDebit': 'Unrestricted Debit (£)',
      'unrestrictedCredit': 'Unrestricted Credit (£)',
      'restrictedDebit': 'Restricted Debit (£)',
      'restrictedCredit': 'Restricted Credit (£)',
      'endowmentDebit': 'Endowment Debit (£)',
      'endowmentCredit': 'Endowment Credit (£) ',

      'currentPeriodDebit': 'Debit (£)',
      'currentPeriodCredit': 'Credit (£)'
    };
    return displayNames[column] || column;
  }
  isDataRow = (index: number, row: any) => row.type === 'data';
  isHeaderRow = (index: number, row: any) => row.type === 'header';
  isFooterRow = (index: number, row: any) => row.type === 'footer';
  GetTrailbalancetemplate() { 

    this.trailBalanceService.GetTrailbalancetemplate(localStorage.getItem('CurrentuserID'), localStorage.getItem('CentralUserId'),
      localStorage.getItem('currentCharityID'), localStorage.getItem('currentPeriod')).subscribe((Response: any) => {
        this.DBTotalUnrestrictedDebit = 0;
        this.DBTotalUnrestrictedCredit = 0;
        this.DBTotalRestrictedCredit = 0;
        this.DBTotalRestrictedDebit = 0;
        this.DBTotalEndowmentDebit = 0;
        this.DBTotalEndowmentCredit = 0;
        this.DBTotalcurrentPeriodDebit = 0
        this.DBTotalcurrentPeriodCredit = 0
        this.DBTotalclosingBalanceDebit=0
        this.DBTotalclosingBalanceCredit=0
        this.DBTotalPY_Debit = 0;
        this.DBTotalPY_Credit = 0;
        debugger
        const entity = Array.isArray(Response?.entity) ? Response.entity : [];       
        const hasRealAccounts =
          entity.length > 6 ||
          entity.some(
            (h: any) =>
              Array.isArray(h.accounts) &&
              h.accounts.some((acc: any) => acc.trailBalanceID && acc.trailBalanceID !== 0)
          );
           
          const Trailbalancelist: any[] = []
          this.MainTrailBalanceTemplate = Response.entity
          this.saveType = Response.entity[0].accounts[2].save_Type;
        this.disablePreview = Response.entity[0].accounts[4].trailBalanceID == 0 ? true : false
          Response.entity.forEach((particulars: TrailBalanceModal) => {
            Trailbalancelist.push({

              'type': 'header',
              "display": true,
              'charityID': localStorage.getItem('currentCharityID'),
              "centralUserId": localStorage.getItem('CentralUserId'),
              'financialPeriodsID': localStorage.getItem('currentPeriod'),
              'userId': localStorage.getItem('CurrentuserID'),
              'dataType': localStorage.getItem('CurrentuserID'),
              'text': particulars.headersName,
              "headersID": particulars.headersID,
              "trailBalanceID": 0,
              "accountsID": 0,
              "uniqueAccountsID": 0,
              "DBuniqueAccountsID": 0,
              "accountCode": '',
              "accountName": 'headercol',
              "headersName": particulars.headersName,
              "particulars": '',
              "nature": '',
              "openingBalanceDebit": 0,
              "openingBalanceCredit": 0,
              "currentPeriodDebit": 0,
              "currentPeriodCredit": 0,
              "unrestrictedDebit": 0,
              "unrestrictedCredit": 0,
              "restrictedDebit": 0,
              "restrictedCredit": 0,
              "endowmentDebit": 0,
              "endowmentCredit": 0,
              "closingBalanceDebit": 0,
              "closingBalanceCredit": 0,
            })
          

            particulars.accounts.forEach((accounts: AccountDetails) => {

              this.DBTotalUnrestrictedDebit = parseFloat((this.DBTotalUnrestrictedDebit + (+accounts.unrestrictedDebit || 0)).toFixed(2));
              this.DBTotalUnrestrictedCredit = parseFloat((this.DBTotalUnrestrictedCredit + (+accounts.unrestrictedCredit || 0)).toFixed(2));

              this.DBTotalRestrictedCredit = parseFloat((this.DBTotalRestrictedCredit + (+accounts.restrictedCredit || 0)).toFixed(2));
              this.DBTotalRestrictedDebit = parseFloat((this.DBTotalRestrictedDebit + (+accounts.restrictedDebit || 0)).toFixed(2));

              this.DBTotalEndowmentDebit = parseFloat((this.DBTotalEndowmentDebit + (+accounts.endowmentDebit || 0)).toFixed(2));
              this.DBTotalEndowmentCredit = parseFloat((this.DBTotalEndowmentCredit + (+accounts.endowmentCredit || 0)).toFixed(2));

              this.DBTotalcurrentPeriodDebit = parseFloat((this.DBTotalcurrentPeriodDebit + (+accounts.currentPeriodDebit || 0)).toFixed(2));
              this.DBTotalcurrentPeriodCredit = parseFloat((this.DBTotalcurrentPeriodCredit + (+accounts.currentPeriodCredit || 0)).toFixed(2));

              this.DBTotalclosingBalanceDebit = parseFloat((this.DBTotalclosingBalanceDebit + (+accounts.closingBalanceDebit || 0)).toFixed(2));
              this.DBTotalclosingBalanceCredit = parseFloat((this.DBTotalclosingBalanceCredit + (+accounts.closingBalanceCredit || 0)).toFixed(2));

              this.DBTotalPY_Debit = parseFloat((this.DBTotalPY_Debit + (+accounts.openingBalanceDebit || 0)).toFixed(2));
              this.DBTotalPY_Credit = parseFloat((this.DBTotalPY_Credit + (+accounts.openingBalanceCredit || 0)).toFixed(2));

           

           

              this.DBTotalCredits += ((+accounts.unrestrictedCredit) + (+accounts.restrictedCredit) + (+accounts.endowmentCredit) + (+accounts.currentPeriodCredit))
              this.DBTotalDebits += ((+accounts.unrestrictedDebit) + (+accounts.restrictedDebit) + (+accounts.endowmentDebit) + (+accounts.currentPeriodDebit))
              Trailbalancelist.push(
                {
                  'type': 'Account',
                  "display": true,
                  'charityID': localStorage.getItem('currentCharityID'),
                  "centralUserId": localStorage.getItem('CentralUserId'),
                  'financialPeriodsID': localStorage.getItem('currentPeriod'),
                  'userId': localStorage.getItem('CurrentuserID'),
                  'dataType': accounts.dataType,
                  'text': particulars.headersName,
                  "headersID": accounts.headersID,
                  "trailBalanceID": accounts.trailBalanceID,
                  "accountsID": accounts.accountsID,
                  "uniqueAccountsID": accounts.uniqueAccountsID,
                  "DBuniqueAccountsID": accounts.uniqueAccountsID,
                  "accountCode": accounts.accountCode,
                  "accountName": accounts.accountName,
                  "headersName": particulars.headersName,
                  "particulars": accounts.particulars,
                  "nature": accounts.nature,
                  "openingBalanceDebit": accounts.openingBalanceDebit != null ? parseFloat(accounts.openingBalanceDebit).toFixed(2) : null,
                  "openingBalanceCredit": accounts.openingBalanceCredit != null ? parseFloat(accounts.openingBalanceCredit).toFixed(2) : null,
                  "currentPeriodDebit": accounts.currentPeriodDebit != null ? parseFloat(accounts.currentPeriodDebit).toFixed(2) : null,
                  "currentPeriodCredit": accounts.currentPeriodCredit != null ? parseFloat(accounts.currentPeriodCredit).toFixed(2) : null,
                  "unrestrictedDebit": accounts.unrestrictedDebit != null ? parseFloat(accounts.unrestrictedDebit).toFixed(2) : null,
                  "unrestrictedCredit": accounts.unrestrictedCredit != null ? parseFloat(accounts.unrestrictedCredit).toFixed(2) : null,
                  "restrictedDebit": accounts.restrictedDebit != null ? parseFloat(accounts.restrictedDebit).toFixed(2) : null,
                  "restrictedCredit": accounts.restrictedCredit != null ? parseFloat(accounts.restrictedCredit).toFixed(2) : null,
                  "endowmentDebit": accounts.endowmentDebit != null ? parseFloat(accounts.endowmentDebit).toFixed(2) : null,
                  "endowmentCredit": accounts.endowmentCredit != null ? parseFloat(accounts.endowmentCredit).toFixed(2) : null,
                  "closingBalanceDebit": accounts.closingBalanceDebit != null ? parseFloat(accounts.closingBalanceDebit).toFixed(2) : null,
                  "closingBalanceCredit": accounts.closingBalanceCredit != null ? parseFloat(accounts.closingBalanceCredit).toFixed(2) : null,
                })

            });
          });
          this.Getbasicinformation()
          this.TrailBalanceTemplate = JSON.parse(JSON.stringify(Trailbalancelist));
          this.ExcelTrailBalanceTemplate = JSON.parse(JSON.stringify(Trailbalancelist));
          this.ExcelTrailBalanceTemplate.forEach(accounts => {
            accounts.openingBalanceDebit = null;
            accounts.openingBalanceCredit = null;
            accounts.currentPeriodDebit = null;
            accounts.currentPeriodCredit = null;
            accounts.unrestrictedDebit = null;
            accounts.unrestrictedCredit = null;
            accounts.restrictedDebit = null;
            accounts.restrictedCredit = null;
            accounts.endowmentDebit = null;
            accounts.endowmentCredit = null;
            accounts.closingBalanceDebit = null;
            accounts.closingBalanceCredit = null;
          });
          this.MainExcelTrailBalanceTemplate = JSON.parse(JSON.stringify(this.ExcelTrailBalanceTemplate))
          this.GetTemplateHeaders()
          this.CalculateTotalcredits_Debits(this.isFundTracking)
          // this.Difference = this.TotalCredits - this.TotalDebits
          this.Difference = parseFloat(this.TotalCredits.toFixed(2)) - parseFloat(this.TotalDebits.toFixed(2));
        debugger

        if ((this.DBTotalRestrictedCredit == this.DBTotalRestrictedDebit && this.DBTotalUnrestrictedCredit == this.DBTotalUnrestrictedDebit && this.DBTotalEndowmentCredit == this.DBTotalEndowmentDebit && this.DBTotalclosingBalanceDebit == this.DBTotalclosingBalanceCredit && this.DBTotalclosingBalanceCredit > 0 && this.DBTotalclosingBalanceDebit > 0)
          || (this.DBTotalcurrentPeriodCredit == this.DBTotalcurrentPeriodDebit && this.DBTotalclosingBalanceDebit == this.DBTotalclosingBalanceCredit && this.DBTotalclosingBalanceCredit > 0 && this.DBTotalclosingBalanceDebit > 0)) {
          this.Showpreview = true;
        }
        
          this.GroupData()
        })

  }


  getAbsoluteDifference(NumberOne: any, NumberTwo: any): number {
    //return Math.abs(NumberOne - NumberTwo);
    const difference = Math.abs(+NumberOne - +NumberTwo);
    return parseFloat(difference.toFixed(2));
  }
  Getbasicinformation() {
    
    const period = localStorage.getItem('currentPeriod');
    const charityId = localStorage.getItem('currentCharityID');

    this.Charities_Service.Getbasicinfo(charityId, period).subscribe((data: any) => {
      this.Basicinfodata = data;
      this.isFundTracking = this.Basicinfodata[0].fund_Tracking
      this.Basicinfodata[0].FinancialYear = this.Basicinfodata[0].financial_Year.split(' ')[1]

      this.Basicinfodata[0].withPrevoiusPeriod = (data[0].withPrevoiusPeriod == 1) ? true : false
      this.SetTrailBalanceColumns()
      localStorage.setItem('FY_Year', this.Basicinfodata[0].financial_Year);



    })
  }
  GetTemplateHeaders() {
    
    // this.Templateheder = this.TrailBalanceTemplate.filter(((header) => header.type == 'header'))
    this.Templateheder = this.TrailBalanceTemplate.filter(header => header.type === 'header');
  }
  CalculateTotalcredits_Debits(IsfundTracking: any) {  debugger
    
    this.TotalUnrestrictedDebit = 0;
    this.TotalUnrestrictedCredit = 0;
    this.TotalRestrictedCredit = 0;
    this.TotalRestrictedDebit = 0;
    this.TotalEndowmentDebit = 0;
    this.TotalEndowmentCredit = 0;
    this.TotalPY_Debit = 0;
    this.TotalPY_Credit = 0;
    this.TotalcurrentPeriodDebit = 0
    this.TotalcurrentPeriodCredit = 0
    // alert('')
    

    this.TrailBalanceTemplate.filter((item) => {
      if (item.dataType== "Data") { 
      //this.TotalUnrestrictedDebit += +item.unrestrictedDebit;
      //this.TotalUnrestrictedCredit += +item.unrestrictedCredit;
      //this.TotalRestrictedCredit += +item.restrictedCredit;
      //this.TotalRestrictedDebit += +item.restrictedDebit;
      //this.TotalEndowmentDebit += +item.endowmentDebit;
      //this.TotalEndowmentCredit += +item.endowmentCredit;
      //this.TotalPY_Debit += +item.openingBalanceDebit;
      //this.TotalPY_Credit += +item.openingBalanceCredit;
      //this.TotalcurrentPeriodDebit += +item.currentPeriodDebit
      //this.TotalcurrentPeriodCredit += +item.currentPeriodCredit

        this.TotalUnrestrictedDebit = parseFloat((this.TotalUnrestrictedDebit + (+item.unrestrictedDebit || 0)).toFixed(2));
        this.TotalUnrestrictedCredit = parseFloat((this.TotalUnrestrictedCredit + (+item.unrestrictedCredit || 0)).toFixed(2));
        this.TotalRestrictedCredit = parseFloat((this.TotalRestrictedCredit + (+item.restrictedCredit || 0)).toFixed(2));
        this.TotalRestrictedDebit = parseFloat((this.TotalRestrictedDebit + (+item.restrictedDebit || 0)).toFixed(2));
        this.TotalEndowmentDebit = parseFloat((this.TotalEndowmentDebit + (+item.endowmentDebit || 0)).toFixed(2));
        this.TotalEndowmentCredit = parseFloat((this.TotalEndowmentCredit + (+item.endowmentCredit || 0)).toFixed(2));
        this.TotalPY_Debit = parseFloat((this.TotalPY_Debit + (+item.openingBalanceDebit || 0)).toFixed(2));
        this.TotalPY_Credit = parseFloat((this.TotalPY_Credit + (+item.openingBalanceCredit || 0)).toFixed(2));
        this.TotalcurrentPeriodDebit = parseFloat((this.TotalcurrentPeriodDebit + (+item.currentPeriodDebit || 0)).toFixed(2));
        this.TotalcurrentPeriodCredit = parseFloat((this.TotalcurrentPeriodCredit + (+item.currentPeriodCredit || 0)).toFixed(2));


      if (IsfundTracking) {
        if (item?.type != "header") {

          this.TotalCredits += ((+item.unrestrictedCredit) + (+item.restrictedCredit) + (+item.endowmentCredit))
          this.TotalDebits += ((+item.unrestrictedDebit) + (+item.restrictedDebit) + (+item.endowmentDebit))
        }
      }

      else {
        if (item?.type != "header") {
          this.TotalCredits += (+item.currentPeriodCredit)
          this.TotalDebits += (+item.currentPeriodDebit)
        }
      }
    }
    })
   // this.TotalUnrestrictedDebit = +this.formatToTwoDecimals(this.TotalUnrestrictedDebit)
   // this.TotalUnrestrictedDebit += +item.unrestrictedDebit;
    this.TotalUnrestrictedCredit = +this.formatToTwoDecimals(this.TotalUnrestrictedCredit)
    this.TotalRestrictedCredit = +this.formatToTwoDecimals(this.TotalRestrictedCredit)
    this.TotalRestrictedDebit = +this.formatToTwoDecimals(this.TotalRestrictedDebit)
    this.TotalEndowmentDebit = +this.formatToTwoDecimals(this.TotalEndowmentDebit)
    this.TotalEndowmentCredit = +this.formatToTwoDecimals(this.TotalEndowmentCredit)
    this.TotalPY_Debit = +this.formatToTwoDecimals(this.TotalPY_Debit)
    this.TotalPY_Credit = +this.formatToTwoDecimals(this.TotalPY_Credit)
    this.TotalcurrentPeriodDebit = +this.formatToTwoDecimals(this.TotalcurrentPeriodDebit)
    this.TotalcurrentPeriodCredit = +this.formatToTwoDecimals(this.TotalcurrentPeriodCredit)
  }
  CurrentPeriod_Calculation_FT(event: any, HeadersID: any, trailBalanceID: any, Nature: any, AccountCode: any, Type: any, uniqueAccountsID: any) {
    debugger
 
    if (event.target.value == '') {
      event.target.value = null
    }

    this.TotalCredits = 0
    this.TotalDebits = 0
    this.Difference = 0


    this.TotalUnrestrictedDebit = 0;
    this.TotalUnrestrictedCredit = 0;
    this.TotalRestrictedCredit = 0;
    this.TotalRestrictedDebit = 0;
    this.TotalEndowmentDebit = 0;
    this.TotalEndowmentCredit = 0;
    this.TotalPY_Debit = 0;
    this.TotalPY_Credit = 0;
    this.TotalcurrentPeriodDebit = 0
    this.TotalcurrentPeriodCredit = 0



    if (Type == 'Unrestricted') {
      this.TrailBalanceTemplate.filter((item) => {
        if (item?.type != "header") {
          if (item.uniqueAccountsID == uniqueAccountsID && Nature == 'Credit') {
            item.unrestrictedCredit = (+event.target.value)
            item.unrestrictedDebit = null
          }
          if (item.uniqueAccountsID == uniqueAccountsID && Nature == 'Debit') {
            item.unrestrictedDebit = (+event.target.value)
            item.unrestrictedCredit = null
          }
          item.closingBalanceCredit = ((+item.unrestrictedCredit) + (+item.restrictedCredit) + (+item.endowmentCredit))
          item.closingBalanceDebit = ((+item.unrestrictedDebit) + (+item.restrictedDebit) + (+item.endowmentDebit))

          this.TotalCredits += ((+item.unrestrictedCredit) + (+item.restrictedCredit) + (+item.endowmentCredit))
          this.TotalDebits += ((+item.unrestrictedDebit) + (+item.restrictedDebit) + (+item.endowmentDebit))
        }
      })

    }

    else if (Type == 'Restricted') {
      this.TrailBalanceTemplate.filter((item) => {
        if (item?.type != "header") {
          if (item.uniqueAccountsID == uniqueAccountsID && Nature == 'Credit') {
            item.restrictedCredit = (+event.target.value)
            item.restrictedDebit = null

          }
          if (item.uniqueAccountsID == uniqueAccountsID && Nature == 'Debit') {
            item.restrictedDebit = (+event.target.value)
            item.restrictedCredit = null
          }
          item.closingBalanceCredit = ((+item.unrestrictedCredit) + (+item.restrictedCredit) + (+item.endowmentCredit))
          item.closingBalanceDebit = ((+item.unrestrictedDebit) + (+item.restrictedDebit) + (+item.endowmentDebit))

          this.TotalCredits += ((+item.unrestrictedCredit) + (+item.restrictedCredit) + (+item.endowmentCredit))
          this.TotalDebits += ((+item.unrestrictedDebit) + (+item.restrictedDebit) + (+item.endowmentDebit))
        }
      })
    }
    else if (Type == 'Endowment') {
      this.TrailBalanceTemplate.filter((item) => {
        if (item?.type != "header") {
          if (item.uniqueAccountsID == uniqueAccountsID && Nature == 'Credit') {
            item.endowmentCredit = (+event.target.value)
            item.endowmentDebit = null
          }

          if (item.uniqueAccountsID == uniqueAccountsID && Nature == 'Debit') {

            item.endowmentDebit = (+event.target.value)
            item.endowmentCredit = null
          }
          item.closingBalanceCredit = ((+item.unrestrictedCredit) + (+item.restrictedCredit) + (+item.endowmentCredit))
          item.closingBalanceDebit = ((+item.unrestrictedDebit) + (+item.restrictedDebit) + (+item.endowmentDebit))

          this.TotalCredits += ((+item.unrestrictedCredit) + (+item.restrictedCredit) + (+item.endowmentCredit))
          this.TotalDebits += ((+item.unrestrictedDebit) + (+item.restrictedDebit) + (+item.endowmentDebit))

        }

      })

    }
    this.CalculateTotalcredits_Debits(this.isFundTracking)

    // this.Difference = (this.TotalCredits - this.TotalDebits)

    this.Difference = parseFloat(this.TotalCredits.toFixed(2)) - parseFloat(this.TotalDebits.toFixed(2));
    debugger



  }
  CurrentPeriod_Calculation(event: any, HeadersID: any, trailBalanceID: any, Nature: any, AccountCode: any, uniqueAccountsID: any) {debugger
    
    this.TotalCredits = 0
    this.TotalDebits = 0

    this.TotalUnrestrictedDebit = 0;
    this.TotalUnrestrictedCredit = 0;
    this.TotalRestrictedCredit = 0;
    this.TotalRestrictedDebit = 0;
    this.TotalEndowmentDebit = 0;
    this.TotalEndowmentCredit = 0;
    this.TotalPY_Debit = 0;
    this.TotalPY_Credit = 0;
    this.TotalcurrentPeriodDebit = 0
    this.TotalcurrentPeriodCredit = 0

    this.TrailBalanceTemplate.filter((item) => {
      if (item?.type != "header") {
        if (item.uniqueAccountsID == uniqueAccountsID && Nature == 'Credit') {
          item.currentPeriodCredit = (+event.target.value)
          item.currentPeriodDebit = null

        }
        if (item.uniqueAccountsID == uniqueAccountsID && Nature == 'Debit') {
          item.currentPeriodCredit = null
          item.currentPeriodDebit = (+event.target.value)



        }
        item.closingBalanceCredit = ((+item.currentPeriodCredit))
          item.closingBalanceDebit = ((+item.currentPeriodDebit))

        //this.TotalCredits += (+item.currentPeriodCredit)
        //this.TotalDebits += (+item.currentPeriodDebit)

        //this.TotalUnrestrictedDebit += +item.unrestrictedDebit;
        //this.TotalUnrestrictedCredit += +item.unrestrictedCredit;
        //this.TotalRestrictedCredit += +item.restrictedCredit;
        //this.TotalRestrictedDebit += +item.restrictedDebit;
        //this.TotalEndowmentDebit += +item.endowmentDebit;
        //this.TotalEndowmentCredit += +item.endowmentCredit;
        //this.TotalPY_Debit += +item.openingBalanceDebit;
        //this.TotalPY_Credit += +item.openingBalanceCredit;
        //this.TotalcurrentPeriodDebit += +item.currentPeriodDebit
        //this.TotalcurrentPeriodCredit += +item.currentPeriodCredit
      }
    })
    // this.Difference = (this.TotalCredits - this.TotalDebits)
    this.CalculateTotalcredits_Debits(this.isFundTracking)
    this.Difference = parseFloat(this.TotalCredits.toFixed(2)) - parseFloat(this.TotalDebits.toFixed(2));
    debugger

  }
 isdirty:any = false;
  MarkDirty() {
    this.datashare.setisdirty(true)
    this.isdirty = true
  }
  CanDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger
    //if (this.CharityDetailsSubForm?.touched || SelectedType.charity_Type != null) {
    if (this.DBTotalCredits != this.TotalCredits || this.DBTotalDebits != this.TotalDebits) {
      this.dataShareService.updateisLoadingResults(false)
      return Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          debugger
          this.datashare.setisdirty(false)
          this.isdirty = false
          //this.CharityDetailsSubForm.markAsUntouched();
          this.dataShareService.updateisLoadingResults(true)
          return true
        } else {
          localStorage.setItem("currentCharityIDFromSwitch", "");
          return false
        }
      })
    } else {
      return true
    }
  }

  sendmail() {
    debugger
    if (this.TrialBalanceForm.valid) {
      this.apiservice.sentmail(this.TrialBalanceForm.getRawValue()).subscribe((Data: any) => {
        debugger
        var reponse = Data;
        if (reponse == "TrialBalanceEmailResponse") {
          Swal.fire({
            html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Mail Server details not configured!</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Please configure Mail Server setting to send an email.',
            iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
            confirmButtonText: "OK",

            allowOutsideClick: false
          }).then((result) => {
            if (result.value) {
            } else {
              return
            }
          })
        }
        else if (reponse == "TrialBalanceTemplateresponse") {
          Swal.fire({
            html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Please complete the Preference</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Preference need to be done.',
            iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
            confirmButtonText: "Ok",
            allowOutsideClick: false
          }).then((result) => {
            if (result.value) {
            } else {
              return
            }
          })
        } else if (reponse == "mail_sent") {
          debugger
          this.dialog.closeAll()
          this.msgService.showToastMessage("success", "Mail sent successfully");
        }
      })
    } else {


      this.TrialBalanceForm.markAllAsTouched()
    }
  }
  Preview(template: any) {
    debugger
    this.ShowSpinner = true
    if (localStorage.getItem('currentCharityID') != null || localStorage.getItem('currentCharityID') != undefined || localStorage.getItem('currentCharityID') != '') {
      this.PeriodID = localStorage.getItem('currentPeriod')
      this.UserId = localStorage.getItem('userID')
      this.CentralUser = localStorage.getItem('CentralUserId')
      this.charityId = localStorage.getItem('currentCharityID')
    }
    this.IsFirstAcctPeriod = true;

    this.reportservice.GetTrailBalance(this.PeriodID, this.UserId, this.CentralUser, this.charityId, this.IsFirstAcctPeriod, localStorage.getItem('fund_Tracking') == 'true' ? true : false,true).subscribe((data: any) => {
      const byteCharacters = atob(data.Item1.toString());
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      this.pdfFile = URL.createObjectURL(blob);

      this.Downloadreportname = "Trial Balance Report.pdf";
      this.dialog.open(template, {
        width: '50%', maxWidth: '100%', maxHeight: 'auto', height: 'auto', disableClose: true
      });
      setTimeout(() => {
        if (this.pdfViewerAutoLoad) {
          this.pdfViewerAutoLoad.pdfSrc = this.pdfFile;
          this.pdfViewerAutoLoad.downloadFileName = this.Downloadreportname;
          this.pdfViewerAutoLoad.page = 1;
          this.pdfViewerAutoLoad.refresh();
        }
      }, 1000)
      this.ShowSpinner = false
    })
  }
  isBodyEmpty(formname?: any): boolean {
    const rawHtml = formname.get('Body')?.value || '';
    const strippedText = rawHtml.replace(/<[^>]*>/g, '').trim();
    return strippedText === '';
  }
  cenceltemplate() {
    debugger
    if (this.TrialBalanceForm.dirty) {
      Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          debugger
          this.datashare.setisdirty(false)
          this.isdirty = false
          this.TrialBalanceForm.markAsUntouched()
          this.TrialBalanceForm.markAsPristine()
          this.TrialBalanceForm.controls['to'].markAsUntouched()
          this.dialog.closeAll()
        }
        else {
          localStorage.setItem("currentCharityIDFromSwitch", "");
          return
        }

      })

    }
    else {
      this.TrialBalanceForm.markAsUntouched()
      this.TrialBalanceForm.markAsPristine()
      this.TrialBalanceForm.controls['to'].markAsUntouched()
      this.dialog.closeAll()

    }
  
  }

  UnlockandAmend() {
    debugger
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Amend) {
      Swal.fire({
        html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Are you sure?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px; padding-right: 30px !important;"> Unlocking the accounting period will allow you to amend the filed accounts and correct any errors. After making any changes, the accounts must be submitted again as an Amended filing. Do you want to unlock and amend the accounting period?</p>`,
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this._UsermanagementService.UnfreezeAP(+fid).subscribe((data: any) => {
            debugger
            this.sharedService.setFinalStatus('InCompleted');
            localStorage.setItem('apFinalised', 'InCompleted')
          })
          //this.save("FinaliseandClose");
        }
        else { }
      })
    }
    else {
      Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel"></h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }
  }
  UnfreezeAP() {
    debugger
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Submit) {
      Swal.fire({
        html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Are you sure?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px; padding-right: 30px !important;"> Do you want to unlock the Accounting Period? </p>`,
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this._UsermanagementService.UnfreezeAP(+fid).subscribe((data: any) => {
            debugger
            const message = "Accounting Period unlocked successfully";
            this.msgService.showToastMessage('success', message)
            this.sharedService.setFinalStatus('InCompleted');
            localStorage.setItem('apFinalised', 'InCompleted')
          })
        }
      })
    } else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }
  }
  gotoSubmissions() {
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Submit) {
      this._UsermanagementService.GoToSubmissions()
    } else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }

  }

}

